// 简化的组件存根
import { ReactNode } from "react";

interface DropdownItemProps {
  children?: ReactNode;
  [key: string]: any;
}

const DropdownItem = ({ children, ...props }: DropdownItemProps) => {
  return <div {...props}>{children}</div>;
};

export default DropdownItem;
